/**
 * Bind all the navigation toggles, for both desktop and mobile
 */
function initNavigation() {
	const Nav = {
		init: function () {
			const openBtn = document.querySelector( '.js-open-menu' );
			const closeBtn = document.querySelector( '.js-close-menu' );
			const submenuToggleBtns = Array.from( document.querySelectorAll( '.js-toggle-submenu' ) );

			if ( openBtn ) {
				openBtn.addEventListener( 'click', this.openMenu.bind( this ) );
			}

			if ( closeBtn ) {
				closeBtn.addEventListener( 'click', this.closeMenu.bind( this ) );
			}

			if ( submenuToggleBtns ) {
				submenuToggleBtns.forEach( ( btn ) => {
					btn.addEventListener( 'click', () => {
						this.toggleSubmenu( btn );
					} );

					btn.parentNode.addEventListener( 'mouseenter', () => {
						this.toggleSubmenu( btn );
					} );

					btn.parentNode.addEventListener( 'mouseleave', () => {
						this.toggleSubmenu( btn );
					} );
				} );
			}
		},
		openMenu: function () {
			if ( event.target.tagName !== 'BUTTON' ) {
				event.target.closest( 'button' ).blur();
			} else {
				event.target.blur();
			}

			document.body.classList.add( 'menu-is-open' );
		},
		closeMenu: function () {
			if ( event.target.tagName !== 'BUTTON' ) {
				event.target.closest( 'button' ).blur();
			} else {
				event.target.blur();
			}

			document.body.classList.remove( 'menu-is-open' );
			this.closeSubmenus( '.nav-main__submenu' );
		},
		toggleSubmenu: function ( btn ) {
			btn.blur();
			const submenu = btn.parentNode.querySelector( '.nav-main__submenu' );
			const submenuHeight = submenu.querySelector( '.nav-main__submenu-items' ).clientHeight;

			if ( submenu.clientHeight > 0 ) {
				submenu.style.height = '0';
				submenu.parentNode.classList.remove( 'is-open' );
			} else {
				this.closeSubmenus( '.nav-main__submenu' );
				submenu.style.height = submenuHeight + 'px';
				submenu.parentNode.classList.add( 'is-open' );
			}
		},
		closeSubmenus: function ( selector ) {
			const menus = Array.from( document.querySelectorAll( selector ) );
			menus.forEach( ( menu ) => {
				menu.parentNode.classList.remove( 'is-open' );
				menu.style.height = '0';
			} );
		},
	};

	Nav.init();
}

/**
 * Returns the offset of an element. This returns the offset relative to the page, so not client.
 *
 * @param el
 * @returns {{top: number, left: number}}
 */
function getOffset( el ) {
	var _x = 0;
	var _y = 0;
	while ( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
		_x += el.offsetLeft - el.scrollLeft;
		_y += el.offsetTop - el.scrollTop;
		el = el.offsetParent;
	}
	return { top: _y, left: _x };
}

/**
 * Initialize the go down buttons. Works with href attribute
 */
function initGoDownButtons() {
	const goDownButtons = document.getElementsByClassName( 'go-down' );

	if ( goDownButtons.length ) {
		[...goDownButtons].forEach( ( element ) => {
			element.addEventListener( 'click', ( event ) => {
				event.preventDefault();

				const href = element.getAttribute( 'href' ),
					scrollTo = getOffset( document.querySelector( href ) ).top;

				window.scrollTo( {
					top: scrollTo - 100,
					behavior: 'smooth',
				} );
			} );
		} );
	}
}

export default {
	init() {
		initNavigation();
		initGoDownButtons();
	},
};
